import { AlertDialog } from '@rocco/ui/dialog/components/AlertDialog';
import { ensureProtocol } from '~/modules/url';

/**
 * A dialog that warns the user about opening an external link. The user can
 * continue to open the link or cancel.
 */
export function ExternalLinkDialog({
    open,
    url,
    onOpenChange,
    onConfirm,
    onCancel,
}: {
    open: boolean;
    url: string;
    onOpenChange: (open: boolean) => void;
    onConfirm?: () => void;
    onCancel?: () => void;
}) {
    // Add protocol if not present. URLs without a protocol will be opened as
    // relative URLs, e.g. www.example.com -> archipro.co.nz/www.example.com.
    const fullUrl = ensureProtocol(url);

    return (
        <AlertDialog
            controlled={{
                open,
                setOpen: onOpenChange,
            }}
            title="Open external link?"
            description={
                <>
                    You're about to open a link outside ArchiPro. Only continue
                    if you trust this destination.
                    <br />
                    <strong>{fullUrl}</strong>
                </>
            }
            onConfirm={() => {
                if (typeof window === 'undefined' || !fullUrl) return;
                window.open(fullUrl, '_blank', 'noopener,noreferrer');
                onConfirm?.();
            }}
            onCancel={onCancel}
        />
    );
}
